import React, { FocusEvent, useRef } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { CampaignSelectProps } from 'models/campaign-mkt';
import * as S from './style';

const CampaignSelect = ({
  disabled = false,
  error = false,
  label,
  onBlur,
  onChange,
  options,
  value = '',
}: CampaignSelectProps): JSX.Element => {
  const selectedOption = options.find((option) => option.id === value);
  const currentValueRef = useRef(value);

  currentValueRef.current = value;

  const handleBlur = (event: FocusEvent<HTMLDivElement>): void => {
    const nextFocusedElement = event.relatedTarget as Node | null;

    if (nextFocusedElement && event.currentTarget.contains(nextFocusedElement))
      return;

    onBlur(currentValueRef.current);
  };

  const handleChange = (nextValue: string): void => {
    currentValueRef.current = nextValue;
    onChange(nextValue);
  };

  return (
    <S.StyledDropdown
      $disabled={disabled}
      $error={error}
      $filled={Boolean(selectedOption)}
      onBlur={handleBlur}
    >
      <S.SelectLabel>{label}</S.SelectLabel>
      <Dropdown.Toggle aria-label={label} disabled={disabled}>
        {selectedOption?.label || ''}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((option) => (
          <Dropdown.Item
            as="button"
            key={option.id}
            onClick={() => handleChange(option.id)}
            type="button"
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </S.StyledDropdown>
  );
};

export default CampaignSelect;
